module.exports = __webpack_public_path__ + "img/刘志伟.49daaf4c.jpg";